export enum UAResources {
  StorageByUAFetchRecords = 'storage_by_unifyapps_fetch_records',
  StorageByUACreateRecord = 'storage_by_unifyapps_create_record',
  StorageByUAUpdateRecordById = 'storage_by_unifyapps_update_record_by_id',
  StorageByUAGetRecordById = 'storage_by_unifyapps_get_record_by_id',
  StorageByUAUpdateRecordFieldsById = 'storage_by_unifyapps_update_record_fields_by_id',
  StorageByUADeleteRecords = 'storage_by_unifyapps_delete_records',
  StorageByUABulkUpsertRecordsById = 'storage_by_unifyapps_bulk_upsert_records_by_id',
  StorageByUAUpdateRecords = 'storage_by_unifyapps_update_records',
  StorageByUABulkCreateRecords = 'storage_by_unifyapps_bulk_create_records',
  AnalyticsByUAQueryReports = 'analytics_by_unifyapps_query_reports',
  AnalyticsByUAExecuteQuery = 'analytics_by_unifyapps_execute_query',
  StandardEntitiesFetchEntities = 'standard_entities_fetch_entities',
  AnalyticsByUAAggregateMetadata = 'analytics_by_unifyapps_aggregate_metadata',
  StorageByUAAggregateMetadata = 'storage_by_unifyapps_aggregate_metadata',
  CommentsByUAFindComments = 'comments_by_unifyapps_find_comments',
  CommentsByUAAddComment = 'comments_by_unifyapps_add_comment',
  CommentsByUAAddReply = 'comments_by_unifyapps_add_reply',
  CommentsByUADeleteComment = 'comments_by_unifyapps_delete_comment',
  CommentsByUAFindReplies = 'comments_by_unifyapps_find_replies',
  CallablesCallAutomation = 'callables_call_automation',
  CallablesCallInterface = 'callables_call_interface',
  CallablesCallAutomationSSE = 'callables_call_automation_streaming',
  CallablesCallAutomationBatch = 'callables_call_automation_batch',
  CallablesCallAutomationAsync = 'callables_call_automation_async',
  CallablesFromAutomation = 'callables_from_automation',
  CallablesReturnToAutomation = 'callables_return_to_automation',
  UserAudit = 'standard_entities_fetch_user_audit',
  StandardEntitiesAudit = 'standard_entities_fetch_audit',
  StandardEntitiesResetPassword = 'standard_entities_reset_password',
  AuditByUAEntityAudit = 'audit_by_unifyapps_get_audit_records_for_asset',
  VariableByUACreateVariables = 'variable_by_unifyapps_create_variables',
  VariableByUACreateList = 'variable_by_unifyapps_create_list',
  CustomHTTPEndpointExecute = 'custom_http_endpoint_execute',
  CustomHTTPEndpointExecuteMultipart = 'custom_http_endpoint_execute_multipart',
  CustomHTTPEndpointExecuteSoap = 'custom_http_endpoint_execute_soap',
  CustomHTTPEndpointExecuteSoapMultipart = 'custom_http_endpoint_execute_soap_multipart',
  CalendarByUAFetchEvents = 'calendar_by_unifyapps_fetch_event',
  TriggerScope = 'trigger_scope',
  StandardEntitiesGetConnections = 'standard_entities_get_connections',
  StandardEntitiesGetConnectionDetails = 'standard_entities_get_connection_details',
  CallablesFromAPI = 'callables_from_api',
  CustomHTTPApplicationExecuteSoap = 'custom_http_application_execute_soap',
  AIEvaluatorByUnifyappsTriggerTaskExecution = 'ai_evaluator_by_unifyapps_trigger_task_execution',
  AuthByUAFetchIdentityProviders = 'auth_by_unifyapps_fetch_identity_providers',
  AuthByUALogin = 'auth_by_unifyapps_login',
  AuthByUATriggerResetPassword = 'auth_by_unifyapps_trigger_reset_password',
  AuthByUAResetPassword = 'auth_by_unifyapps_reset_password',
  AuthByUAValidateResetPasswordSession = 'auth_by_unifyapps_validate_reset_password_session',
  AuthByUAVerifyMfa = 'auth_by_unifyapps_verify_mfa',
  AuthByUAReTriggerMfa = 'auth_by_unifyapps_re_trigger_mfa',
}

// includes all resource types where the user selects a callable to invoke (outbound callables).
// CallablesFromAutomation and CallablesReturnToAutomation are intentionally excluded:
// they represent inbound event bindings (automation calling the interface), not user-invocable
// callables, and do not carry the automationId / callableInterfaceId input fields used here.
export const CALLABLE_DATA_SOURCE_TYPES = new Set<UAResources>([
  UAResources.CallablesCallAutomation,
  UAResources.CallablesCallInterface,
  UAResources.CallablesCallAutomationSSE,
  UAResources.CallablesCallAutomationBatch,
  UAResources.CallablesCallAutomationAsync,
]);
